import React, { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { Flex, Layout, Spin, Typography } from 'antd';

import dataGripStore from 'ts/store/DataGrip';
import viewNameStore, { ViewNameEnum } from 'ts/store/ViewName';
// import DropZone from 'ts/components/DropZone';
import Sponsor from 'ts/components/Sponsor';
import SplashScreen from 'ts/components/SplashScreen';
import Confirm from 'ts/components/ModalWindow/Confirm';

import PageWrapper from './PageWrapper';
import Team from './Team/index';
import Person from './Person/index';
import PrintAll from './PrintAll/index';
import Settings from './Settings/index';
import DebugPage from './Debug/index';
import MainWrapper from './MainWrapper/MainWrapper';
import GoogleAuth from '../components/GoogleAuth';
import styles from './styles/styles.module.scss';
import globalStore from 'ts/store/Global';
// import Welcome from './Welcome';

function ViewWithCharts() {
  return (
    <>
      <Sponsor />
      <Confirm />
      <Routes>
        <Route
          path="/settings"
          element={
            <PageWrapper>
              <Settings />
            </PageWrapper>
          }
        />
        <Route
          path="/debug"
          element={
            <PageWrapper>
              <DebugPage />
            </PageWrapper>
          }
        />
        <Route
          path="/print"
          element={
            <PageWrapper>
              <PrintAll />
            </PageWrapper>
          }
        />
        <Route
          path="/:type/:page"
          element={
            <PageWrapper>
              <Team />
            </PageWrapper>
          }
        />
        <Route
          path="/:type/:page/:userId"
          element={
            <PageWrapper>
              <Person />
            </PageWrapper>
          }
        />
        <Route
          path="*"
          element={
            <PageWrapper>
              <Team />
            </PageWrapper>
          }
        />
      </Routes>
    </>
  );
}

let bugInReactWithDoubleInit = 1;
const Main = observer(() => {
  const view = viewNameStore.view;

  function ViewWithWelcome() {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/contributors/list" replace />} />
        <Route
          path="/contributors/*"
          element={
            <Layout>
              <Layout.Header className={styles.headerStyle}>
                <Typography.Text strong className={styles.textStyle}>
                  Logged in as {globalStore.userData?.name || 'UNKNOWN'}
                </Typography.Text>
              </Layout.Header>
              <Layout.Content>
                <MainWrapper />
              </Layout.Content>
            </Layout>
          }
        />
        <Route
          path="/projects"
          element={
            <Layout>
              <Layout.Header className={styles.headerStyle}>
                <Typography.Text strong className={styles.textStyle}>
                  Logged in as {globalStore.userData?.name || 'UNKNOWN'}
                </Typography.Text>
              </Layout.Header>
              <Layout.Content>
                <MainWrapper />
              </Layout.Content>
            </Layout>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Layout>
                <Layout.Header className={styles.headerStyle}>
                  <Typography.Text strong className={styles.textStyle}>
                    Logged in as{' '}
                    {globalStore.userData
                      ? globalStore.userData.name
                      : 'UNKNOWN'}
                  </Typography.Text>
                </Layout.Header>
                <Layout.Content>
                  <MainWrapper />
                  {/*<Welcome />*/}
                </Layout.Content>
              </Layout>
            </>
          }
        />
      </Routes>
    );
  }

  useEffect(() => {
    globalStore.setUserData();
  }, []);

  useEffect(() => {
    // @ts-ignore
    const list = window?.report || [];
    if (list?.length && bugInReactWithDoubleInit !== list?.length) {
      bugInReactWithDoubleInit = list?.length;
      dataGripStore.asyncSetCommits(list);
    } else {
      viewNameStore.toggle(ViewNameEnum.WELCOME);
    }
  }, []);

  useEffect(() => {
    if (view !== ViewNameEnum.INFO) return;
    setTimeout(() => {
      window.location.hash = '#/team/total';
    }, 0);
  }, [view]);

  if (view === ViewNameEnum.EMPTY) return null;

  if (!globalStore?.userData && !globalStore?.userData?.name) {
    return <Flex>
      <Spin></Spin>
    </Flex>;
  }
 
  if (globalStore.isUnauthorized) {
    return (
      <>
        <GoogleAuth onSuccess={() => globalStore.setUserData()} />
      </>
    );
  }

  return (
    <Routes>
      {/* <Route path="/gitstat" element={<GitStatLayout />}>
        <Route path="byuser" element={<CommitStat />} />
        <Route path="something1" element={<h1>content something1</h1>} />
        <Route path="something2" element={<h1>content something2</h1>} />
        <Route path="something3" element={<h1>content something3</h1>} />
        <Route path="" element={<Navigate to="byuser" replace />} />
      </Route> */}
      <Route
        path="*"
        element={
          <>
            {view === ViewNameEnum.WELCOME && <ViewWithWelcome />}
            {view === ViewNameEnum.INFO && <ViewWithCharts />}
            <SplashScreen />
            {/*<DropZone*/}
            {/*  onChange={(type: string, data: any[]) => {*/}
            {/*    if (type !== 'dump') return;*/}
            {/*    dataGripStore.asyncSetCommits(data);*/}
            {/*  }}*/}
            {/*/>*/}
          </>
        }
      />
    </Routes>
  );
});

export default Main;
